import { createFileRoute } from '@tanstack/react-router'
import { BookingLinkCard } from '@/features/share-booking-link'
import { PageHeader } from '@/shared/ui/page-header'

export const Route = createFileRoute('/_app/settings')({
  component: SettingsPage,
})

function SettingsPage() {
  return (
    <div className="flex h-full min-h-0 flex-col">
      <PageHeader
        title="Настройки"
        description="Личные настройки — сейчас здесь только ссылка бронирования."
      />
      <div className="min-h-0 flex-1 overflow-y-auto overscroll-contain px-gutter pb-safe-8">
        <div className="max-w-2xl">
          <BookingLinkCard />
        </div>
      </div>
    </div>
  )
}
